export default "__VITE_ASSET__B6y0wqtU__"